module.exports = __webpack_public_path__ + "static/media/shield-cross.5fc4ce19.svg";